import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const flightTransactionReport = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Flight/TransactionReport`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("Error fetching flight Transaction Report:", error);

    // Check if the error is an Axios error
    if (error.response) {
      // Server responded but returned an error code (4xx, 5xx)
      const { status, data } = error.response;
      console.error("Server error:", status, data);

      // You can throw a custom error for your UI
      throw new Error(
        data?.message ||
        `Server returned status ${status}. Please try again later.`
      );

    } else if (error.request) {
      // Request was made but no response (network/server down)
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");

    } else {
      // Something else happened
      console.error("Unexpected error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const flightUnflownTicketReport = async (requestBody) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Flight/AllUnflownTicket`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("Error fetching flight Transaction Report:", error);

    if (error.response) {
      const { status, data } = error.response;
      console.error("Server error:", status, data);

      throw new Error(
        data?.message ||
        `Server returned status ${status}. Please try again later.`
      );

    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");

    } else {
      console.error("Unexpected error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const flightSaleSummaryReport = async (requestBody) => {
  console.log("requestBody:",requestBody)
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Flight/SaleSummary`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("Error fetching flight Transaction Report:", error);

    if (error.response) {
      const { status, data } = error.response;
      console.error("Server error:", status, data);

      throw new Error(
        data?.message ||
        `Server returned status ${status}. Please try again later.`
      );

    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");

    } else {
      console.error("Unexpected error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const CancelledBookingsReport = async (requestBody) => {
  console.log("requestBody:",requestBody)
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/Reports/Flight/AllCancelledBookings`,
      requestBody,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected response status: ${response.status}`);
    }

  } catch (error) {
    console.error("Error fetching flight Transaction Report:", error);

    if (error.response) {
      const { status, data } = error.response;
      console.error("Server error:", status, data);

      throw new Error(
        data?.message ||
        `Server returned status ${status}. Please try again later.`
      );

    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please check your connection.");

    } else {
      console.error("Unexpected error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};